/**
 * What a full-pane wait says while it waits. Drawn at random, never the same
 * one twice in a row. House rules: one to three words, present tense, a
 * trailing ellipsis, PG. Half are generic and half are the trade's own.
 */
export const LOADING_PHRASES: readonly string[] = [
  "Loading…",
  "Warming up…",
  "Gathering details…",
  "One sec…",
  "Tidying up…",
  "Almost there…",
  "Rolling out…",
  "Sorting the stack…",
  "Pulling it together…",
  "Knocking…",
  "Finding the address…",
  "Measuring twice…",
  "Checking the pitch…",
  "Counting squares…",
];
